import React from 'react';

import { Box, Title } from '../common';
import Message from './message';

const message = `We are unable to perform a basic history check on this vehicle.
	Please contact the seller for more information.`;

const VHCPlaceholder = () => {
    return (
        <Box>
            <Title>Vehicle history</Title>
            <Message data-q="motors-vhc-badge-text">{message}</Message>
        </Box>
    );
};

export default VHCPlaceholder;
